// extracted by mini-css-extract-plugin
export default {"WrapperLissensIndex":"ChangeAttestation_WrapperLissensIndex__JyF6-"};